

const UtilsLocalizedExcelString = (lang, row) => {
var stringLocalized = "";
  switch (lang) {
    case "ar":
     stringLocalized = row[3] !== undefined ? row[3] : "";
      break;
    case "en":
      stringLocalized = row[1] !== undefined ? row[1] : "";
      break;
    case "fr":
        stringLocalized = row[2] !== undefined ? row[2].replaceAll("&#39;", "'") : "";
      break;
    case "ru":
         stringLocalized = row[5] !== undefined ? row[5] : "";
      break;
    case "zh":
         stringLocalized = row[4] !== undefined ? row[4] : "";
      break;
       case "es":
         stringLocalized = row[6] !== undefined ? row[6] : "";
      break;
    default:
        stringLocalized = "";
  }
 return stringLocalized;
}
export default UtilsLocalizedExcelString;